$(() => {
    let rellax = new Rellax('.rellax');
});